// extracted by mini-css-extract-plugin
export default {"image":"displayImage_image__gyv2V","imageStyle":"displayImage_imageStyle__fVE5N"};